import { useLibraryVersionId } from "../../navigation/libraries";
import { libraryVersionsApi } from "../../services/api/libraryVersions";
import FileListTabPage from "../files/FileListTabPage";

export default function LibraryVersionFilesTabPage() {
    return <FileListTabPage api={libraryVersionsApi.files} ownerId={useLibraryVersionId()} />;
}
